import { render, staticRenderFns } from "./thirdAgree.vue?vue&type=template&id=6b3265bf&scoped=true"
import script from "./thirdAgree.vue?vue&type=script&lang=js"
export * from "./thirdAgree.vue?vue&type=script&lang=js"
import style0 from "./thirdAgree.vue?vue&type=style&index=0&id=6b3265bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3265bf",
  null
  
)

export default component.exports